import React, { useEffect, useState } from "react";
import "../../../StyleSheet/MainComponent/LoginPage/LoginPage.scss";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import Password from "../../AppComponent/InputFields/Password";
import validator from "validator";
import { useDispatch, useSelector } from "react-redux";
import { getUserAction, setLaguage, settheCustomerUDSemployeeloginresponse } from "../../../Redux/Slice";
import logo from "../../../Assets/AppComponent/Qpms/White_logo.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import worldimg from "../../../Assets/AppComponent/WorldImgs/Layer_1.png";
import Select from "react-dropdown-select";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import gif from "../../../Assets/loader.gif";
import { setTheIdOne, setTheUDSTOKEN } from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import config from "../../../Redux/Config"; // Use this line if using configuration file

const LoginPage = (props) => {
  const { languageOptions, Lang, setLang } = props;

  const state = useSelector((state) => state);

  const EnglishData = data;
  const HindiData = hindiDatas;
  const Datas = {
    email: "",
    Password: "",
  };
  const [InputData, setInputDatas] = useState(Datas);
  const [EmailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [isvalid, setvalid] = useState(true);
  const [validateType, setValidatetype] = useState(null);
  const [UDSTOKEN, setUDSTOken] = useState(null);
  const navigate = useNavigate();

  const Navigate = useNavigate()



  // const [Lang, setLang] = useState(1)
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const dispatch = useDispatch();
  const validate = () => {
    const numericvalue = InputData.email.replace(/\D/g, "");
    if (!isNaN(numericvalue) && numericvalue.length === 10) {
      setvalid(true);
      setValidatetype("phone number");
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(InputData.email)) {
      setvalid(true);
      setValidatetype("email");
    } else {
      setvalid(false);
      setValidatetype(null);
    }
  };
  const requiredVersion = config.requiredVersion; // For configuration file


  useEffect(() => {
    if (localStorage.getItem("websiteversion") == null) {
      localStorage.clear();
      navigate("/");
      dispatch(setTheUDSTOKEN(""));
      localStorage.setItem("websiteversion", requiredVersion);
      console.log("version", 1);
    } else if (
      localStorage.getItem("websiteversion") == requiredVersion
    ) {
      console.log(
        "version",
        requiredVersion,
        localStorage.getItem("websiteversion")
      );
    } else {
      localStorage.clear();
      navigate("/");
      dispatch(setTheUDSTOKEN(""));
      console.log("version", 3);
    }
  }, []);

  const handleSubmit = () => {
    var a = 0;
    // ErrorEmail(a)
    // Passworderror(a)
    localStorage.clear();

    if (!validator.isEmail(InputData.email)) {
      setEmailError("*Enter valid mail id");
      a = 1;
    }

    var reg =
      "^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[d]){1,})(?=(.*[W]){1,})(?!.*s).{8,}$";
    if (validator.isEmpty(InputData.Password)) {
      setPasswordError("*Password is required");
      a = 1;
    }

    // if (InputData.Password.length < 10) {
    //     setPasswordError("*enter valid password")
    //     a = 1;
    // }

    if (a == 0) {
      dispatch(getUserAction(InputData));
    }
  };
  const HandleSubmits = (event) => {
    event.preventDefault();
  };
  //-----------------Language---Options---
  useEffect(() => {
    dispatch(setLaguage("English"));
  }, []);
  const LanguageChange = (e) => {
    console.log(e.target.value, "values");
    props.onChange(e);

    dispatch(setLaguage(e.target.value));
    // if (e.target.value == "English") {
    //     setLang(1)
    // }
    // else {
    //     setLang(0)
    // }
  };
  //--------____Forgot------------_Password-----------
  const handleClick = () => {
    // window.location.href = "/forgotpassword";
    Navigate("/forgotpassword")
  };
  const HandleSubmit = (e) => {
    e.preventDefault();
  };

  // setInterval(() => {
  //   dispatch(setTheIdOne(3));
  // }, 6900);


  return (
    <>
      <div className="qpms-loginpage ">
        <div className="  Conatiningpart">
          <div className="Welcomepart">
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                )}
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.Content.Content.map((item) => (
                      <p>{item.para1}</p>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Content.Content.map((item) => (
                      <p>{item.para1}</p>
                    ))}
                  </>
                )}


              </div>
            </div>
          </div>
          <div className=" loginpart">
            <div className="Loginwrapped">
              <div className="Udslog">
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                )}

                <form onSubmit={HandleSubmit} autoComplete="on">
                  <div className="Input-Inner">
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.InputLabel.map((item) => (
                          <>
                            <Email
                              value={InputData.email}
                              onChange={(e) => {
                                setEmailError("");
                                HandleChanges(e);
                              }}
                              Error={EmailError}
                              label={item.labelEm}
                              type={"text"}
                              isvalid={isvalid}
                              validateType={validateType}
                            />
                            <Password
                              value={InputData.Password}
                              onChange={(e) => {
                                setPasswordError("");
                                HandleChanges(e);
                              }}
                              Error={PasswordError}
                              label={item.labelPas}
                              // autoCompleted={"on"}
                             autoCompleted={"current-password"}

                            />
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.InputLabel.map((item) => (
                          <>
                            <Email
                              value={InputData.email}
                              onChange={(e) => {
                                setEmailError("");
                                HandleChanges(e);
                              }}
                              Error={EmailError}
                              label={item.labelEm}
                              type={"text"}
                              isvalid={isvalid}
                              validateType={validateType}
                            />
                            <Password
                              value={InputData.Password}
                              onChange={(e) => {
                                setPasswordError("");
                                HandleChanges(e);
                              }}
                              Error={PasswordError}
                              label={item.labelPas}
                             autoCompleted={"current-password"}
                              />
                          </>
                        ))}
                      </>
                    )}
                  </div>
                  <div className="SubmitButton">
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.Button.Button1.map((item) => (
                          <CustomButton
                            children="Submit"
                            onClick={handleSubmit}
                            type={"submit"}
                            className="ButtonCSS"
                          >
                            {item.ButtonName}
                          </CustomButton>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.Button.Button1.map((item) => (
                          <CustomButton
                            children="Submit"
                            onClick={handleSubmit}
                            type={"submit"}
                            className="ButtonCSS"
                          >
                            {item.ButtonName}
                          </CustomButton>
                        ))}
                      </>
                    )}
                  </div>


                  <div className="FortgotPassword" onClick={handleClick}>
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.ForgotPassword.map((item) => (
                          <p>{item.Forgot}</p>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.ForgotPassword.map((item) => (
                          <p>{item.Forgot}</p>
                        ))}
                      </>
                    )}
                  </div>

                </form>
              </div>


            </div>



          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
